/*
 * THE RECONNECTING SCREEN (decision 887): what a cold load shows when /api/me
 * did not answer, in place of the sign-in screen it used to fall back to.
 *
 * WHY. On 25 Oct the server was slow for an hour and /api/me failed or timed
 * out; the app read the failure as "nobody is signed in" and showed sign-in to
 * a coach whose session was perfectly good, who then spent several long tries
 * signing in again against the same slow server. A failure is not an answer,
 * which is the rule the wake-up check already holds (decision 324): it
 * reports nothing rather than a zero. This is the same rule at the session
 * boundary.
 *
 * IT RETRIES BY ITSELF, which is the whole of what it says: the caller re-asks
 * on a backoff and when the app comes back to the foreground, and the button
 * only moves the next try forward. No apology and no error styling; the copy
 * says what is happening and what will happen next.
 */

import { useTranslation } from "react-i18next";

import { Brand } from "../components/Brand";
import styles from "./SignIn.module.css";

export function Reconnecting({ trying, onRetry }: { trying: boolean; onRetry: () => void }) {
  const { t } = useTranslation();
  return (
    <div className={styles.screen}>
      <div className={styles.card}>
        <div className={styles.brand}>
          <Brand variant="lockup" height={34} />
        </div>
        <h1 className={styles.heading}>{t("reconnecting.heading")}</h1>
        <p>{t("reconnecting.body")}</p>
        <button className={styles.outline} type="button" onClick={onRetry} disabled={trying}>
          {trying ? t("reconnecting.trying") : t("reconnecting.retry")}
        </button>
      </div>
    </div>
  );
}
